export enum MeasurementUnit {
  UNIDADE = 'UNIDADE',
  KG = 'KG',
  METROS = 'METROS',
  LITROS = 'LITROS',
}
